enum DisplayNames {
  Menu = 'Menu',
  MenuButton = 'MenuButton',
  MenuDivider = 'MenuDivider',
  MenuGroup = 'MenuGroup',
  MenuItem = 'MenuItem',
  MenuList = 'MenuList'
}

export default DisplayNames;
